// src/App.js
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess, logout } from "./Redux/slices/authSlice";
import { useEffect } from "react";
import Footer from "./components/home/Footer/index";
import MainBox from "./pages/Mainbox/index";
import Header from "./components/home/Header/index";
import { ToastContainer } from "react-toastify";
import FinishInterview from "./pages/Avatar/Interview/FinishInterview";
import EndNote from "./pages/Avatar/Interview/EndInterview";
import InterviewQuestions from "./pages/Avatar/Interview/InterviewQuestions";
import AvatarLanding from "./pages/Avatar/Landing/AvatarLanding";
import GoLink from "./components/home/GoLink";
import WelcomeText from "./pages/Avatar/Landing/WelcomeText";
import WaitingRoom from "./pages/Avatar/Interview/WaitingRoom";
import AdminLandingPage from "./pages/admin/AdminLandingPage";
import AddOrganization from "./pages/admin/AddOrganization";
import "./App.css";
import OrganizationLandingPage from "./pages/organization/OrganizationLandingPage";
import Candidate from "./pages/Candidate";
import InterviewerDashboard from "./pages/Interviewer/InterviewerDashboard";
import {
  AdminRoute,
  OrgAdminRoute,
  InterviewerRoute,
  CandidateRoute,
  HRRoute,
  TP_InterviewerRoute,
} from "./contexts/ProtectedRoute";
import Homepage from "./components/home/Homepage";
import About from "./components/home/About";
import SupportForm from "./components/home/Support";
import ActivationPage from "./components/home/Active";
import HRdashboard from "./pages/HR/HRdashboard";
import InterviewerJoining from "./pages/InterviewerJoining/InterviewerJoining";
import TP_Dashboard from "./pages/TP_Interviewer/TP_dashboard";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);

  // Hydrate Redux state on app load
  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const role = sessionStorage.getItem("role");
    const name = sessionStorage.getItem("name");
    const organizationId =
      localStorage.getItem("organizationId") ||
      sessionStorage.getItem("organizationId");
    const adminId = localStorage.getItem("admin_id");
    const orgUserId = sessionStorage.getItem("orgUserId");
    const candidateId = localStorage.getItem("candidate_id");

    if (accessToken && role) {
      dispatch(
        loginSuccess({
          name,
          role,
          adminId: adminId || null,
          organizationId: organizationId || null,
          orgUserId: orgUserId || null,
          candidateId: candidateId || null,
          accessToken,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      // Handle both specific key removal and localStorage.clear()
      if (event.key === "accessToken" || event.key === null) {
        if (!localStorage.getItem("accessToken")) {
          dispatch(logout());
          if (isAuthenticated) {
            navigate("/login", { replace: true });
          }
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch, navigate, isAuthenticated]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        if (!localStorage.getItem("accessToken") && isAuthenticated) {
          dispatch(logout());
          navigate("/login", { replace: true });
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch, navigate, isAuthenticated]);
  // Auto-redirect logged-in users away from the public base URL
  useEffect(() => {
    if (isAuthenticated && (location.pathname === "/" || location.pathname === "/home")) {
      // Read the role using your cross-tab fallback logic
      const storedRole = sessionStorage.getItem("role") || localStorage.getItem("role");

      // Route the user to their respective dashboard
      if (storedRole === "Admin" || storedRole === "System Admin") {
        navigate("/adminLanding", { replace: true });
      } else if (storedRole === "Organization Admin" || storedRole === "OrgAdmin") {
        navigate("/OrgAdminLanding", { replace: true });
      } else if (storedRole === "HR") {
        navigate("/HRLanding", { replace: true });
      } else if (storedRole === "Interviewer") {
        navigate("/interviewerLanding", { replace: true });
      } else if (storedRole === "TP_Interviewer" || storedRole === "TP_User") {
        navigate("/tp-interviewerLanding", { replace: true });
      } else if (storedRole === "Candidate") {
        navigate("/candidateLanding", { replace: true });
      }
    }
  }, [isAuthenticated, location.pathname, navigate]);

  const isAdminLanding =
    location.pathname === "/adminLanding" ||
    location.pathname === "/organizationLanding" ||
    location.pathname === "/hrLanding" ||
    location.pathname === "/orgadminLanding" ||
    location.pathname === "/organizationLanding/jobDescription" ||
    location.pathname === "/interviewerLanding" ||
    location.pathname === "/tp-interviewerLanding";

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {!isAdminLanding && <Header />}
      <div
        style={{
          paddingTop: isAdminLanding ? 0 : "80px", // adjust to your header height
        }}
        >
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/interviewerjoining" element={<InterviewerJoining/>}/>
        <Route path="/login" element={<MainBox />} />
        <Route path="/register" element={<MainBox />} />
        <Route path="/orgLogin" element={<MainBox />} />
        <Route path="/forgotPassword" element={<MainBox />} />
        <Route path="/otpVerification" element={<MainBox />} />
        <Route path="/updatePassword" element={<MainBox />} />
        <Route path="/changepassword" element={<MainBox />} />
        <Route path="/success" element={<MainBox />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/support" element={<SupportForm />} />
        <Route path="/active" element={<ActivationPage />} />
        {/* Protected routes for Admin */}
        <Route
          path="/adminLanding"
          element={
            <AdminRoute>
              <AdminLandingPage />
            </AdminRoute>
          }
        />
        <Route
          path="/adminLanding/addOrganization"
          element={
            <AdminRoute>
              <AddOrganization />
            </AdminRoute>
          }
        />
        {/* Protected routes for Organization Admin */}
        <Route
          path="/OrgAdminLanding"
          element={
            <OrgAdminRoute>
              <OrganizationLandingPage />
            </OrgAdminRoute>
          }
        />
        {/* Protected routes for Interviewer */}
        <Route
          path="/interviewerLanding"
          element={
            <InterviewerRoute>
              <InterviewerDashboard />
            </InterviewerRoute>
          }
        />
          <Route
          path="/tp-interviewerLanding"
          element={
            <TP_InterviewerRoute>
              <TP_Dashboard />
            </TP_InterviewerRoute>
          }
        />
        {/* Protected routes for HR */}
        <Route
          path="/HRLanding"
          element={
            <HRRoute>
              <HRdashboard />
            </HRRoute>
          }
        />
        {/* Protected routes for Candidate */}
        <Route
          path="/candidateLanding"
          element={
            <CandidateRoute>
              <Candidate />
            </CandidateRoute>
          }
        />
        <Route
          path="/avatarLanding"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/welcomeText"
          element={
            <CandidateRoute>
              <WelcomeText />
            </CandidateRoute>
          }
        />
        <Route
          path="/goLink"
          element={
            <CandidateRoute>
              <GoLink />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/startInterview"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/captureIcons"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/end"
          element={
            <CandidateRoute>
              <EndNote />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/finish"
          element={
            <CandidateRoute>
              <FinishInterview />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/question"
          element={
            <CandidateRoute>
              <InterviewQuestions />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/captureicons"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/captureVideo"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/startCapture"
          element={
            <CandidateRoute>
              <AvatarLanding />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/waitingroom"
          element={
            <CandidateRoute>
              <WaitingRoom />
            </CandidateRoute>
          }
        />
        <Route
          path="/interview/EndInterview"
          element={
            <CandidateRoute>
              <EndNote />
            </CandidateRoute>
          }
        />
      </Routes>
      </div>
    {!isAdminLanding && <Footer />}
    </>
  );
}

export default App;
